/****************************************************
 * Module Name:  proforma.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { useRef, useState } from "react";
import { DataGridPro, GridToolbar, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, FormControlLabel, FormGroup, Switch, Tooltip, Typography, TextField, Stack, MenuItem, Menu, IconButton } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { useEffect } from "react";
import Select from "react-select";
import CircularProgress from "@mui/material/CircularProgress";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import renderCellExpand from "../common/dataGridCellExpand";
import StoneDetailModal from "../common/stoneDetailModal";
import Utility from "../../utility/utility";
import Constants from "../../utility/constants";
import SellMemoModal from "../operations/sellMemoModal";
import SalesProxy from "../../utility/proxy/manager/reportSalesProxy";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import CommonSnackbar from "../common/commonSnackBar";
import { FaFileInvoice } from "react-icons/fa";
import DeleteIcon from "@mui/icons-material/Delete";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import DeleteProformaModal from "./deleteProformaModal";
import { LoadingButton } from "@mui/lab";
import CommonStoneSelection from "../common/commonStoneSelection";
import NoPermission from "../common/noPermission";
import { BsFilePdf } from "react-icons/bs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PDFModal from "../common/pdfModal";
import dayjs from "dayjs";
import StoneMediaModal from "../common/stoneMediaModal";
import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import PageTitle from "../common/pageTitle";
import Download from "@mui/icons-material/Download";
import { createExcelFile } from "../common/createExcelFile";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";
import { TbTableExport } from "react-icons/tb";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled, alpha } from "@mui/material/styles";
import UsersettingsProxy from "../../utility/proxy/manager/usersettingsProxy";
import { VscRunAll } from "react-icons/vsc";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.tableLayouts = {
  Mylayout: {
    fillColor: function (rowIndex, node, columnIndex) {
      return rowIndex % 2 === 0 ? "#CCCCCC" : null;
    },
  },
};

const StyledMenuButtons = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 100,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      fontSize: 15,
      padding: "4px 12px",
      '& .MuiSvgIcon-root': {
        fontSize: 16,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const Proforma = () => {

  const local_Permission = Constants.USER_PERMISSION.filter((iPermission) =>
    iPermission.permissionid === Constants.PERMISSIONS.SALES_PROFORMA);
  const localRead_Permission = local_Permission.find(iPermission => iPermission.type === "READ") !== undefined;

  const invoice_Permission = Constants.USER_PERMISSION.filter((iPermission) =>
    iPermission.permissionid === Constants.PERMISSIONS.DIRECTINVOICE);

  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [showSellModal, setShowSellModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("");
  const [customerData, setCustomerData] = useState({
    customer: "",
    customerOptions: [],
  });
  const [stoneData, setStoneData] = useState([]);
  const [listData, setListData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [selectedProformas, setSelectedProformas] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [saveLoadingButton, setSaveLoadingButton] = useState(false);
  const [saveInvoiceLoadingButton, setSaveInvoiceLoadingButton] = useState(false);
  const [loadingDeleteButton, setLoadingDeleteButton] = useState(false);
  const [memoLoader, setMemoLoader] = useState(false);
  const [fetchData, setFetchData] = useState(false);
  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [show, setShow] = useState(false);
  const [proformaIds, setProformaIds] = useState([]);
  const [deleteModalTitle, setDeleteModalTitle] = useState("");
  const [groupBy, setGroupBy] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState("");
  const [filterValues, setFilterValues] = useState({});
  const [suratIdPermission, setSuratIdPermission] = useState(false);
  const [measurementsPermission, setMeasurementsPermission] = useState(false);
  const [depthPermission, setDepthPermission] = useState(false);
  const [tablepercentPermission, setTablepercentPermission] = useState(false);
  const [crownanglePermission, setCrownanglePermission] = useState(false);
  const [pdfName, setPdfName] = useState("");
  const [pdfByte, setPdfByte] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [enableConvertToInvoiceButton, setEnableConvertToInvoiceButton] = useState(true);
  const [stoneMediaURL, setStoneMediaURL] = useState([]);
  const [showStoneMediaModal, setShowStoneMediaModal] = useState(false);

  const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
  const [selectedTotalSize, setSelectedTotalSize] = useState("0");
  const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
  const [selectedavgPrice, setSelectedavgPrice] = useState("0");
  const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");
  const [openInvoice, setOpenInvoice] = useState(false);
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [columnNames, setColumnNames] = useState([]);
  const [extraPacket, setExtraPacket] = useState([]);

  // eslint-disable-next-line
  const [fullExcelPermission, setFullExcelPermission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.DIRECT_EXCEL_DOWNLOAD_FULL
    )
  );

  const buttonMinWidth = Utility.isReadAllowed(fullExcelPermission) ? "130px" : "100px";

  const extraPacketRef = useRef(extraPacket);

  useEffect(() => {
    extraPacketRef.current = extraPacket;
  }, [extraPacket]);

  // Create a connection
  const ws = useRef(null);

  const startScanning = () => {

    if (!ws.current) {
      ws.current = new WebSocket(Constants.RFID_API);
    }

    // Open WebSocket connection and start scanning
    if (!ws.current || ws.current.readyState === WebSocket.CLOSED) {
      // WebSocket doesn't exist or was closed — create new one
      ws.current = new WebSocket(Constants.RFID_API);
      ws.current.onopen = () => {
        ws.current.send("START_SCAN");
      };
    } else if (ws.current.readyState === WebSocket.CONNECTING) {
      // Still connecting — safely attach onopen
      ws.current.onopen = () => {
        ws.current.send("START_SCAN");
      };
    } else if (ws.current.readyState === WebSocket.OPEN) {
      // Already open — send immediately
      ws.current.send("START_SCAN");
    }

    // Listen for incoming messages from WebSocket
    let lstTags = new Set();
    ws.current.onmessage = (e) => {
      let message = typeof e.data === 'string' ? e.data : String(e.data);
      if (message.includes("TAG: ")) {
        const parts = message.split("TAG: ");
        if (parts.length === 2) {
          const remaining = parts[1].trim(); // remove extra whitespace
          remaining.split(',').forEach(str => lstTags.add(str.trim())); // split and trim each item
        }

        if (mainData.length > 0) {
          setTagsSelections(lstTags);
        }
      } else if (message.includes("SCAN_COMPLETED")) {
        ws.current.close();
        ws.current.onclose = () => {
          getStoneIdByTagId();
        }
      }
    };
  }

  const setTagsSelections = (tags) => {
    //tags is array or string which are tag sample ['t1','t2']
    let lStockData = mainData;
    let iNewSelected = 0;
    let iUnSelectedTags = 0;
    let selectedCheckBox = [];
    let tagsFound = [];
    let tagsNotFound = [];

    for (let loopCnt = 0; loopCnt < lStockData.length; loopCnt++) {
      if (lStockData[loopCnt].tag && tags.has(lStockData[loopCnt].tag)) {
        selectedCheckBox.push(lStockData[loopCnt].stoneid);
        tagsFound.push(lStockData[loopCnt].tag);
        iNewSelected++;
      }
    }

    tagsNotFound = [...tags].filter(tag => !tagsFound.includes(tag));
    iUnSelectedTags = tags.size - iNewSelected;

    setMainData(() => {
      let selectedStone = [];
      let unSelectedStone = [];
      lStockData.forEach((res) => {
        if (selectedCheckBox.includes(res.stoneid)) {
          selectedStone.push(res);
        } else {
          unSelectedStone.push(res);
        }
      });
      return [...selectedStone, ...unSelectedStone];
    });
    setSelectionModel(selectedCheckBox);
    if (tagsNotFound.length > 0) {
      setExtraPacket(prev => Array.from(new Set([...prev, ...tagsNotFound])));
    }

    return {
      NewSelectedStones: iNewSelected,
      UnusedTags: iUnSelectedTags,
    };
  };

  const getStoneIdByTagId = () => {
    if (extraPacketRef.current.length > 0) {
      StoneProxy.GetStoneIdByTagId(extraPacketRef.current, (response) => {
        if (response) {
          let resultString = Object.entries(response)
            .map(([stoneid, tag]) => `${stoneid}: ${tag}`)
            .join(', ');

          if (Object.entries(response).length < extraPacketRef.current.length) {
            const usedTags = new Set(Object.values(response));
            const extraTags = extraPacketRef.current.filter(tag => !usedTags.has(tag));

            const extraTagString = extraTags.map(tag => `STONE_ID: ${tag}`).join(', ');
            resultString = resultString + ', ' + extraTagString;
          }

          setShowSuccessSnackbar(true);
          setSuccessMessage(`You have ${resultString} extra package on your RF Machine`);
          setSnackbarVariant("error");
          setExtraPacket([]);
          ws.current = null;
        } else {
          setShowSuccessSnackbar(true);
          setSuccessMessage(Constants.APiFailErrorMessage);
          setSnackbarVariant("error");
          ws.current = null;
          setExtraPacket([]);
        }
      })
    }
  }

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    PageTitle("SALES_PROFORMA");
    if (Constants.loggedInUser.usertype === "E") {
      prepareAllUserData();
      getOpenInvoiceValue();
    }
  }, []);

  useEffect(() => {
    let selectedStoneProforma = handleUniqueProforma(selectionModel, listData);
    setSelectedProformas(selectedStoneProforma);

    if (selectedStoneProforma.length <= 0) {
      setEnableConvertToInvoiceButton(true);
    } else {
      const customerid = selectedStoneProforma[0].customerid;
      let flag = false;

      for (const proforma of selectedStoneProforma) {
        if (customerid !== proforma.customerid) {
          flag = true;
          break;
        }
      }

      setEnableConvertToInvoiceButton(flag);
    }

    if (selectionModel.length <= 0) {
      loadTotalData(mainData);
      return;
    }
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size
    mainData.forEach((iData) => {
      if (selectionModel.includes(iData.stoneid)) {
        let pricePerCarat = iData.discountprice
        totalSize += iData.size;
        totalPrice += (iData.stoneprice);
        total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
      }
    });
    setNoOfSelectedStones(selectionModel.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(totalPrice / totalSize)
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  }, [selectionModel]);

  const loadTotalData = (data) => {

    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size

    data.forEach((iData) => {
      let pricePerCarat = iData.discountprice;
      totalSize += iData.size;
      totalPrice += (iData.stoneprice);
      total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

    });
    setNoOfSelectedStones(data.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  };

  const prepareAllUserData = () => {

    SalesProxy.GetCustomersCreatedProforma(
      Utility.isReadAllowed(local_Permission) && localRead_Permission ? Constants.loggedInUser.locationid : -1,
      Utility.isReadAllowed(local_Permission) && localRead_Permission ? -1 : Constants.loggedInUser.id,
      Constants.loggedInUser.usertype,
      (response) => {
        if (response) {
          setAllUserData(response);
        }
      });
  }

  const setAllUserData = (response) => {
    let optionsArray = [];
    optionsArray.push({ value: "*", label: "-- ANY --" });
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.companyname,
      };
      optionsArray.push(option);
      return true;
    });
    setCustomerData({
      ...customerData,
      customerOptions: optionsArray,
      customer:
        customerData.customer === "" && optionsArray.length > 0
          ? [optionsArray[0]]
          : customerData.customer,
    });
    setFetchData(true);
  };

  const getOpenInvoiceValue = () => {
    UsersettingsProxy.GetIsInvoiceOpen((response) => {
      if (response) {
        setOpenInvoice(response.isinvoiceopen);
      }
    });
  }

  const handleSelection = (data) => {
    const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, mainData, selectionModel);

    setMainData(tempStockData);
    setSelectionModel(tempSelectionModel);
  }

  useEffect(() => {
    if (fetchData) {
      if (customerData.customer || Constants.loggedInUser.usertype === "C") {
        handleSearch();
      }
    }
  }, [fetchData, customerData.customer]);

  const fullOptionToValue = (selectedData) => {
    let newArr = [];
    selectedData.map((data) => {
      if (data.value === "*") {
        return customerData.customerOptions.map((option) => {
          if (option.value !== "*") {
            newArr.push(option.value);
            return true;
          }
          return true;
        });
      }
      return true;
    })
    return Utility.GetValueArrayWithStarReplace(selectedData, newArr);
  };

  const handleSearch = () => {
    let stoneids = data.split(",").filter(Boolean).map(Number);

    let requestdata = {
      from: fromDate === "" ? "" : dayjs(fromDate).format('YYYY-MM-DD') + "T00:00:00.000Z",
      to: toDate === "" ? "" : dayjs(toDate).format('YYYY-MM-DD') + "T23:59:59.999Z",
      customerid: Constants.loggedInUser.usertype === "C"
        ? [Constants.loggedInUser.id]
        : fullOptionToValue(customerData.customer),
      status: ["NEW", "INPROGRESS"],
      stoneid: stoneids,
      locationid: Utility.isReadAllowed(local_Permission) && localRead_Permission ? Constants.loggedInUser.locationid : - 1,
    };
    setMemoLoader(true);

    SalesProxy.GetAllProformaByStoneid(requestdata, (response) => {
      if (response) {
        const uniqueFilterValues = {
          status: Utility.getDistinctOptions(response, "status"),
          exchangecurrency: Utility.getDistinctOptions(response, "exchangecurrency"),
          user: Utility.getDistinctOptions(response, "userid"),
          broker: Utility.getDistinctOptions(response, "brokerid"),
          customer: Utility.getDistinctOptions(response, "customerid"),
          employee: Utility.getDistinctOptions(response, "employeeid"),
          invoicecustomer: Utility.getDistinctOptions(response, "invoicecustomerid"),
          tradingcompany: Utility.getDistinctOptions(response, "tradingcompanyid"),
        };
        const combinedFilterValues = {
          status: uniqueFilterValues.status,
          exchangecurrency: uniqueFilterValues.exchangecurrency,
          user: uniqueFilterValues.user.map(value => {
            const matchingItem = response.find(item => item.userid === value);
            return matchingItem ? `${value} | ${matchingItem.username}` : [];
          }),
          broker: uniqueFilterValues.broker.map(value => {
            const matchingItem = response.find(item => item.brokerid === value);
            if (matchingItem) {
              let displayValue = matchingItem.brokerid === -1 ? " - " : `${matchingItem.brokerid} | ${matchingItem.brokercompanyname}`;
              return displayValue;
            }
            return [];
          }),
          customer: uniqueFilterValues.customer.map(value => {
            const matchingItem = response.find(item => item.customerid === value);
            return matchingItem ? `${value} | ${matchingItem.customercompanyname}` : [];
          }),
          employee: uniqueFilterValues.employee.map(value => {
            const matchingItem = response.find(item => item.employeeid === value);
            return matchingItem ? `${value} | ${matchingItem.employeeusername}` : [];
          }),
          invoicecustomer: uniqueFilterValues.invoicecustomer.map(value => {
            const matchingItem = response.find(item => item.invoicecustomerid === value);
            if (matchingItem) {
              let displayValue = (!matchingItem.invoicecustomerid) ? " - " : `${matchingItem.invoicecustomerid} | ${matchingItem.invoicecustomercompanyname}`;
              return displayValue;
            }
            return [];
          }),
          tradingcompany: uniqueFilterValues.tradingcompany.map(value => {
            const matchingItem = response.find(item => item.tradingcompanyid === value);
            return matchingItem ? `${value} | ${matchingItem.tradingcompanyname}` : [];
          }),
        };
        setFilterValues(combinedFilterValues);
        setListData(response);
        handleArray(response);
        prepareColumns();
        setMemoLoader(false);
        setFetchData(false);
      } else {
        setMemoLoader(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
      }
    });

    Constants.USER_COLUMN_PERMISSION.forEach(iColumnPermission => {
      if (iColumnPermission === "7a913460-41e0-441d-85b9-1f33d71416fb") {
        setSuratIdPermission(true);
      }
      if (iColumnPermission === "13d48508-b8c9-4661-8a6c-9fb22a3408a3") {
        setMeasurementsPermission(true);
      }
      if (iColumnPermission === "567202e6-c31c-4c19-9998-1cacae05af6e") {
        setDepthPermission(true);
      }
      if (iColumnPermission === "70498a64-1f5f-4f03-8910-a6d7851e4aba") {
        setTablepercentPermission(true);
      }
      if (iColumnPermission === "c4e65984-1682-4c1e-812b-8938e9078b2d") {
        setCrownanglePermission(true);
      }
    })
  };

  const base64ToUint8Array = (base64) => {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  };

  const openPdfInNewTab = (base64String) => {
    const byteArray = base64ToUint8Array(base64String);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  };


  const sellStones = (data) => {
    setLoadingButton(true);
    StoneProxy.SellStones(data, (responseData) => {
      if (responseData && responseData.invoicepdf) {
        handleSearch();
        if (openInvoice)
          openPdfInNewTab(responseData.invoicepdf);
        setShowSellModal(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage("Stones sold successfully");
        setSnackbarVariant("success");
        setLoadingButton(false);
      } else {
        setShowSellModal(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage(responseData ? responseData.error : Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingButton(false);
      }
    });
  };

  const updateProforma = (data) => {
    setSaveLoadingButton(true);
    StoneProxy.UpdatePerforma(data, (responseData) => {
      if (responseData) {
        handleSearch();
        setShowSellModal(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage(responseData.errorMessage);
        setSnackbarVariant(responseData.status === "Success" ? "success" : "error");
        setSaveLoadingButton(false);
      } else {
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setSaveLoadingButton(false);
      }
    });
  };

  const updateProformaToInvoice = (data) => {
    setSaveInvoiceLoadingButton(true);
    StoneProxy.UpdatePerformaToInvoice(data, (responseData) => {
      if (responseData) {
        handleSearch();
        if (openInvoice)
          openPdfInNewTab(responseData.invoicepdf);
        setShowSellModal(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage("Proforma Updated & Invoice Created successfully");
        setSnackbarVariant("success");
        setSaveInvoiceLoadingButton(false);
      } else {
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setSaveInvoiceLoadingButton(false);
      }
    });
  };

  const downloadPDF = (proformaid, fileBytes) => {
    setPdfByte(fileBytes);
    setPdfName(`Profroma_` + proformaid + `.pdf`);
    openModal()
  }

  const handleValidation = (customer) => {
    //TODO do validation if needed here
    return true;
  };

  const handleArray = (lListData) => {
    let newMainData = [];
    if (lListData.length > 0) {
      lListData.map((list) => {

        list.stones.map((stone) => {
          newMainData.push({
            perfomaid: stone.perfomaid,
            stoneid: stone.stoneid,
            suratid: stone.stonedetail.suratid,
            date: list.date,
            customercompanyname: list.customercompanyname,
            employeeusername: list.employeeusername,
            stoneprice: stone.stoneprice,
            discount: stone.actualdiscount,
            discountprice: stone.discountprice,
            originalprice: stone.originalprice,
            neworiginalprice: stone.neworiginalprice,
            status: stone.stonedetail.status,
            clarity: stone.stonedetail.clarity,
            certificateid: stone.stonedetail.certificateid,
            colortype: stone.stonedetail.colortype,
            color: stone.stonedetail.color,
            colordescriptions: stone.stonedetail.colordescriptions,
            country: stone.stonedetail.country,
            cut: stone.stonedetail.cut,
            cutpolsym: stone.stonedetail.cutpolsym,
            flo: stone.stonedetail.flo,
            lab: stone.stonedetail.lab,
            location: stone.stonedetail.location,
            locationid: stone.stonedetail.locationid,
            pol: stone.stonedetail.pol,
            quality: stone.stonedetail.quality,
            shade: stone.stonedetail.shade,
            shape: stone.stonedetail.shape,
            size: stone.stonedetail.size,
            exchangerate: list.exchangerate,
            exchangecurrency: list.exchangecurrency,
            shippingcost: list.shippingcost,
            stonelocation: stone.stonelocation,
            sym: stone.stonedetail.sym,
            addlesspercent: stone.addlesspercent,
            addToInvoice: stone.addtoinvoice,
            stoneoldstatus: stone.stoneoldstatus,
            stonetransitstatus: stone.stonetransitstatus,
            tradingcompanylocation: list.companylocation,
            companylocationid: list.companylocationid,
            stonetype: stone.stonedetail.stonetype,
            measurements: stone.stonedetail.measurements,
            depth: stone.stonedetail.depth,
            depthpercent: stone.stonedetail.depthpercent,
            tablepercent: stone.stonedetail.tablepercent,
            crownangle: stone.stonedetail.crownangle,
            stonemediaurl: stone.stonedetail.stonemediaurl,
            lrhalf: stone.stonedetail.lrhalf,
            comment: stone.stonedetail.comment,
            fancycolor1: stone.stonedetail.fancycolor1,
            length: stone.stonedetail.length,
            tinge: stone.stonedetail.tinge,
            milky: stone.stonedetail.milky,
            fancycolorintensity: stone.stonedetail.fancycolorintensity,
            fancycolorovertone: stone.stonedetail.fancycolorovertone,
            open: stone.stonedetail.open,
            strln: stone.stonedetail.strln,
            age: stone.stonedetail.age,
            keytosymbols: stone.stonedetail.keytosymbols,
            h_and_a: stone.stonedetail.h_and_a,
            eyeclean: stone.stonedetail.eyeclean,
            tableinc: stone.stonedetail.tableinc,
            sideinc: stone.stonedetail.sideinc,
            luster: stone.stonedetail.luster,
            tableblack: stone.stonedetail.tableblack,
            sideblack: stone.stonedetail.sideblack,
            tag: stone.stonedetail.tag,
          });
          return true;
        });
        return true;
      });
    }
    setMainData(newMainData);
    loadTotalData(newMainData);
  };

  const handleUniqueProforma = (stoneIds, lListData) => {
    let listIdTracker = 0;
    let newMainData = [];
    let selectedProformas = [];
    lListData.map((list) =>
      list.stones.map((stone) =>
        stoneIds.includes(stone.stoneid) ? selectedProformas.push(list) : true
      )
    );
    if (selectedProformas.length > 0) {
      selectedProformas
        .sort((a, b) => a.id - b.id)
        .map((list) => {
          if (listIdTracker === 0 || list.id !== listIdTracker) {
            listIdTracker = list.id;
            newMainData.push({
              proformaid: list.id,
              id: list.id,
              status: list.status,
              date: list.date,
              export: list.export,
              countryoforigin: list.countryoforigin,
              ensuredby: list.ensuredby,
              portofloading: list.portofloading,
              countryoffinaldestination: list.countryoffinaldestination,
              shippedby: list.shippedby,
              portofdischarge: list.portofdischarge,
              terms: list.terms,
              days: list.days,
              finaldestination: list.finaldestination,
              bankthrough: list.bankthrough,
              remarks: list.remarks,
              tradingcompanyname: list.tradingcompanyname,
              tradingcompanyid: list.tradingcompanyid,
              companylocation: list.companylocation,
              shippingcost: list.shippingcost,
              exchangerate: list.exchangerate,
              exchangecurrency: list.exchangecurrency,
              userid: list.userid,
              username: list.username,
              usercompanyname: list.usercompanyname,
              brokerid: list.brokerid,
              brokername: list.brokername,
              brokercompanyname: list.brokercompanyname,
              customerid: list.customerid,
              customername: list.customername,
              customercompanyname: list.customercompanyname,
              employeeid: list.employeeid,
              employeeusername: list.employeeusername,
              finalpayableamount: list.finalpayableamount,
              invoicecustomercompanyname: list.invoicecustomercompanyname,
              invoicecustomerid: list.invoicecustomerid,
              companylocationid: list.companylocationid
            });
          }
          return true;
        });
    }
    return newMainData;
  };

  const createPdf = () => {
    if (selectionModel.length === 0) return;
    let flag = true;
    let stonetype = null;

    const data = selectionModel.map(stoneid => {
      const match = mainData.find(data => data.stoneid === stoneid);
      if (!match) return null;

      if (stonetype && stonetype !== match.stonetype) {
        if (stonetype === 'N' || match.stonetype === 'N') {
          flag = false;
        }
      } else if (!stonetype) {
        stonetype = match.stonetype;
      }

      return {
        proformaid: match.perfomaid,
        stoneid: stoneid
      };
    }).filter(item => item && item.proformaid != null);

    if (!flag) {
      setShowSuccessSnackbar(true);
      setSuccessMessage("Stonetype mismatch. Select stones with same stonetype");
      setSnackbarVariant("warning");
      return;
    }

    if (data.length === 0) return;

    StoneProxy.GetProformaPDF(data, (response) => {
      if (response) {
        setShowSuccessSnackbar(true);
        setSuccessMessage("Pdf created successfully");
        setSnackbarVariant("success");
        openPdfInNewTab(response);
      }
      else {
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
      }
    })
  }

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const handleClose = () => {
    setShowStoneDetailModal(false);
    setShowSuccessSnackbar(false);
  };

  const handleProformaDelete = (id, message) => {
    setLoadingDeleteButton(true);
    SalesProxy.DeleteProforma(id, (response) => {
      if (response) {
        setShow(false);
        handleSearch();
        setShowSuccessSnackbar(true);
        setSuccessMessage(message);
        setSnackbarVariant("success");
        setLoadingDeleteButton(false);
      } else {
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingDeleteButton(false);
      }
    });
  };

  const prepareColumns = () => {
    let columnNames = [];
    columnNames.push(
      {
        field: "perfomaid",
        headerName: "PROF. ID",
        headerAlign: "center",
        width: 70,
        type: "number",
        valueFormatter: (params) => params.value,
        align: "center",
      },
      {
        field: "employeeusername",
        headerName: "EMPLOYEE",
        headerAlign: "center",
        align: "center",
        width: 200,
        renderCell: renderCellExpand,
      },
      {
        field: "customercompanyname",
        headerName: "CUSTOMER COMPANY NAME",
        headerAlign: "center",
        align: "center",
        width: 200,
        renderCell: renderCellExpand,
      },
      {
        field: "stonetransitstatus",
        headerName: "TRANSIT STATUS",
        headerAlign: "center",
        width: 155,
        align: "center",
        renderCell: (params) => params.value === null ? " - " :
          (params.value === "NEW" && params.row.tradingcompanylocation === params.row.stonelocation ?
            (params.row.stoneoldstatus !== null ? Constants.STONE_TRANSIT_STATUS[params.row.stoneoldstatus] : Constants.STONE_TRANSIT_STATUS["RECEIVED"]) :
            Constants.STONE_TRANSIT_STATUS[params.value])
      },
      {
        headerName: "DATE",
        field: "date",
        type: "date",
        width: 75,
        valueGetter: (params) => {
          if (params.value) {
            return new Date(params.value);
          }
          return null;
        },
        renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.date),
        headerAlign: "center",
        align: "center",
      },
    );

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        columnNames.push(columnData);
        if (columnData.field === "stoneid") {
          columnNames.push({
            field: "suratid",
            headerName: "REF NO",
            headerAlign: "center",
            align: "center",
            width: 90,
            renderCell: renderCellExpand,
          });
        }
      }
    });
    setColumnNames(columnNames);
  }

  const columnsData = {
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 90,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      headerAlign: "center",
      width: 80,
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },

    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      width: 40,
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      width: 65,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "d4992de9-92ab-4f9e-ba12-6c746e935611": {
      field: "colordescriptions",
      headerName: "COLOR DESCRIPTIONS",
      headerAlign: "center",
      align: "center",
      width: 160,
      renderCell: renderCellExpand,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      width: 75,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 50,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      width: 40,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      width: 40,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      width: 60,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "originalprice",
      headerName: "RAP",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "discountprice",
      headerName: "PPC",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "stoneprice",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "stonelocation",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 100,
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      width: 40,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "cf694b75-ba5d-4a73-8fcf-e7566974c4b6": {
      field: "media",
      headerName: "MEDIA",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: (params) => (
        <Tooltip title={"Stone Media"} sx={{ cursor: "pointer" }}>
          <VideoLibraryTwoToneIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setStoneMediaURL(params.row.stonemediaurl);
              setShowStoneMediaModal(true);
            }} />
        </Tooltip>
      ),
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 140,
      renderCell: renderCellExpand,
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "66dfbc62-477f-42f0-8097-56c5d8329156": {
      field: "lrhalf",
      headerName: "LR HALF",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH %",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "77e48fa7-d118-4ab8-865b-9b85b32a004f": {
      field: "fancycolor1",
      headerName: "F.COLOR",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "a1299782-d545-4d70-bcbc-7d576e396d64": {
      field: "length",
      headerName: "LENGTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "b38b9fdf-bfb8-43c6-82a2-1e366fa71523": {
      field: "tinge",
      headerName: "TINGE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.tinge.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "c95089ee-166d-4783-817c-2638f6d40df1": {
      field: "milky",
      headerName: "MILKY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.milky.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "c9aa6ee7-30e3-423e-a534-80bb5ef7bbaf": {
      field: "fancycolorintensity",
      headerName: "F.COL.INTENSITY",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    "ccba9873-174e-4060-963a-9893c3625bb2": {
      field: "fancycolorovertone",
      headerName: "OVERTONE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "dfd5488a-b600-4e75-9735-98c26f78dc84": {
      field: "strln",
      headerName: "STAR LENGTH",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "e32fe363-07cc-4307-82d2-82ae1069b5be": {
      field: "age",
      headerName: "AGE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      valueGetter: (params) => {
        if (params.value)
          return Utility.ConvertDateToAge(params.value);
        else
          return null;
      },
      renderCell: (params) => {
        return params.value;
      },
    },
    "e683145c-29dd-4d41-af1a-518ff80090d2": {
      field: "keytosymbols",
      headerName: "KEY TO SYMBOLS",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "e993a4f7-7c50-4d83-abae-fccc03382742": {
      field: "h_and_a",
      headerName: "H&A",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "f2fe7666-6489-40ce-b4b7-040c68c88bf3": {
      field: "eyeclean",
      headerName: "EYE CLEAN",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "f3223657-c8d2-449c-b2f5-5a54c78401ce": {
      field: "tableinc",
      headerName: "TABLE INC",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "f114ad2c-8560-4da7-9b03-03ba6bfe39a5": {
      field: "sideinc",
      headerName: "SIDE INC",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "2a6475ff-481f-48c6-9e92-3ede0b97d7c0": {
      field: "luster",
      headerName: "LUSTER",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "556ae429-3605-4df4-88d8-b5223fc2e2fb": {
      field: "tableblack",
      headerName: "TABLE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "5c70d1ca-2a7b-4660-8160-0beff7ad1150": {
      field: "sideblack",
      headerName: "SIDE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
  };

  const materialDefaultColumns = [
    {
      headerName: "PDF",
      field: "performapdf",
      renderCell: (params) => (
        <BsFilePdf size={25} color="red" onClick={() => downloadPDF(params.row.id, params.row.performapdf)} />
      ),
      export: false,
      width: 55,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "INVOICE",
      field: "converttoinvoice",
      width: 70,
      align: "center",
      renderCell: (params) => {
        return (
          <Tooltip title="Convert this Proforma to Invoice">
            <Button
              variant="contained"
              component="label"
              size="small"
              sx={{ minWidth: "30px", height: "30px", "& .MuiButton-startIcon": { margin: 0 } }}
              startIcon={<FaFileInvoice />}
              color="success"
              onClick={(e) => {
                e.stopPropagation()
                setShowSellModal(!showSellModal);
                setStoneData(() =>
                  mainData.filter((data) => data.perfomaid === params.row.id)
                );
                setSelectedProformas([params.row]);
              }}
            >
            </Button>
          </Tooltip >
        )
      },
    },
    {
      headerName: "DELETE",
      field: "deleteproforma",
      width: 70,
      align: "center",
      renderCell: (params) => {
        return (
          <Tooltip title="Delete this Proforma">
            <Button
              variant="contained"
              component="label"
              size="small"
              sx={{ minWidth: "30px", height: "30px", "& .MuiButton-startIcon": { margin: 0 } }}
              startIcon={<DeleteIcon size="large" />}
              color="error"
              onClick={(e) => {
                e.stopPropagation()
                let ids = [];
                params.row.stones.map((stone) => ids.push(stone.stoneid));
                setShow(true);
                setProformaIds(ids);
                setDeleteModalTitle(
                  "Are you sure you want to Delete this Proforma ?"
                );
              }}
            >
            </Button>
          </Tooltip>
        )
      },
    },
    {
      headerName: "PROF. ID",
      field: "id",
      headerAlign: "center",
      width: 95,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "STATUS",
      field: "status",
      width: 80,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.status : [],
      filterOperators: Utility.combinedFilters(),
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "STONETYPE",
      field: "stonetype",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
      width: 95,
    },
    {
      headerName: "DATE",
      field: "date",
      type: "date",
      width: 75,
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.date),
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "EMPLOYEE",
      field: "employeeusername",
      width: 200,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.customer : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return `${params.row.employeeid} | ${params.row.employeeusername}`;
      },
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {`${params.row.employeeid} | ${params.row.employeeusername}`}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "CUSTOMER COMPANY",
      field: "customerid",
      width: 200,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.customer : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return `${params.row.customerid} | ${params.row.customercompanyname}`;
      },
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {`${params.row.customerid} | ${params.row.customercompanyname}`}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "BROKER COMPANY",
      field: "brokerid",
      width: 150,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.broker : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return params.row.brokerid === -1 ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`;
      },
      renderCell: (params) => {
        let displayValue = params.row.brokerid === -1 ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {displayValue}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "EXCHANGE RATE",
      field: "exchangerate",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
      renderCell: renderCellExpand
    },
    {
      headerName: "FINAL PAYABLE AMT",
      field: "finalpayableamount",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 135,
      renderCell: renderCellExpand
    },
    {
      headerName: "TRADING COMPANY",
      field: "tradingcompanyid",
      width: 175,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.tradingcompany : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return `${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`;
      },
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {`${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "USER",
      field: "userid",
      width: 145,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.user : [],
      filterOperators: Utility.combinedFilters(),
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return `${params.row.userid} | ${params.row.username}`;
      },
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '5px', marginLeft: '10px' }}>
            {`${params.row.userid} | ${params.row.username}`}
          </span>
        </div>
      ),
    },
    {
      headerName: "CUSTOMER INVOICE COMPANY",
      field: "invoicecustomerid",
      width: 215,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.invoicecustomer : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return (!params.row.invoicecustomerid) ? " - " : `${params.row.invoicecustomerid} | ${params.row.invoicecustomercompanyname}`;
      },
      renderCell: (params) => {
        let displayValue = (!params.row.invoicecustomerid) ? " - " : `${params.row.invoicecustomerid} | ${params.row.invoicecustomercompanyname}`
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {displayValue}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "TRADING COMPANY LOCATION",
      field: "companylocation",
      headerAlign: "center",
      type: "singleSelect",
      width: 200,
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
    },
    {
      headerName: "EXCHANGE CURRENCY",
      field: "exchangecurrency",
      headerAlign: "center",
      align: "center",
      width: 170,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.exchangecurrency : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand
    },
    {
      headerName: "SHIPPING COST",
      field: "shippingcost",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 110,
      renderCell: renderCellExpand
    },
    {
      headerName: "EXPORT",
      field: "export",
      renderCell: (params) =>
        params.row.export ? (
          <CheckIcon color="success" />
        ) : (
          <ClearIcon color="error" />
        ),
      headerAlign: "center",
      align: "center",
      width: 65
    },
    {
      headerName: "COUNTRY OF FINAL DESTINATION",
      field: "countryoffinaldestination",
      headerAlign: "center",
      align: "center",
      width: 225,
      renderCell: renderCellExpand
    },
    {
      headerName: "COUNTRY OF ORIGIN",
      field: "countryoforigin",
      headerAlign: "center",
      align: "center",
      width: 145,
      renderCell: renderCellExpand
    },

    {
      headerName: "FINAL DESTINATION",
      field: "finaldestination",
      headerAlign: "center",
      align: "center",
      width: 135,
      renderCell: renderCellExpand
    },
    {
      headerName: "ENSURED BY",
      field: "ensuredby",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
      width: 95,
    },
    {
      headerName: "BANK THROUGH",
      field: "bankthrough",
      renderCell: (params) =>
        params.row.bankthrough ? (
          <CheckIcon color="success" />
        ) : (
          <ClearIcon color="error" />
        ),
      headerAlign: "center",
      width: 115,
      align: "center",
    },

    {
      headerName: "PORT OF LOADING",
      field: "portofloading",
      headerAlign: "center",
      align: "center",
      width: 130,
      renderCell: renderCellExpand
    },
    {
      headerName: "SHIPPED BY",
      field: "shippedby",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "PORT OF DISCHARGE",
      field: "portofdischarge",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: renderCellExpand
    },
    {
      headerName: "REMARKS",
      field: "remarks",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
      width: 75
    },
    {
      headerName: "TERMS",
      field: "terms",
      align: "center",
      width: 55,
      renderCell: renderCellExpand
    },
    {
      headerName: "DAYS",
      field: "days",
      align: "center",
      width: 55,
      renderCell: (params) => params.value,
    },
    {
      headerName: "DUE DATE",
      field: "duedate",
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.duedate),
      headerAlign: "center",
      align: "center",
      width: 85,
    },
  ];

  const columns = columnNames.filter(iColumn => {
    if (iColumn.field === "suratid" && !suratIdPermission) return false;
    if (iColumn.field === "measurements" && !measurementsPermission) return false;
    if (iColumn.field === "depth" && !depthPermission) return false;
    if (iColumn.field === "tablepercent" && !tablepercentPermission) return false;
    if (iColumn.field === "crownangle" && !crownanglePermission) return false;
    return true;
  });

  const getSummaryData = (rowdata) => {

    let data = [];
    if (selectionModel && selectionModel.length > 0) {
      data = rowdata.filter((data) => selectionModel.includes(data.stoneid));
    } else {
      data = rowdata;
    }

    let noOfStones = 0;
    let totalSize = 0;
    let totalAmount = 0;
    let total = 0;

    data.forEach(item => {
      noOfStones += 1;

      if (Utility.isValueValid(item.size)) {
        totalSize += Number(item.size);
      }

      if (Utility.isValueValid(item.stoneprice)) {
        totalAmount += Number(item.stoneprice);
      }

      if (
        Utility.isValueValid(item.discountprice) &&
        Utility.isValueValid(item.discount) &&
        Utility.isValueValid(item.size)
      ) {
        const effectivePrice = (100 * Number(item.discountprice)) / (100 + Number(item.discount));
        total += Number(item.size) * effectivePrice;
      }
    });

    return {
      ID: noOfStones,
      CTS: (Number(totalSize)).toFixed(2),
      DIS: (Number((100 - (totalAmount / total) * 100) * -1)).toFixed(2),
      PPC: (Number(totalAmount / totalSize)).toFixed(2),
      TOTAL: (Number(totalAmount)).toFixed(2),
    };

  }

  const getExcelData = (rowdata, fullExcel) => {
    let data = [];

    if (selectionModel && selectionModel.length > 0) {
      data = rowdata.filter((data) => selectionModel.includes(data.stoneid));
    } else {
      data = rowdata;
    }

    const excelData = data.map(item => {

      return {
        REPORT: item.certificateid,
        SHAPE: item.shape,
        ID: item.stoneid,
        CTS: item.size,
        COL: item.colortype === "WHITE" ? item.color : item.colordescriptions,
        CLA: item.clarity,
        CUT: item.cut ? item.cut : " ",
        POL: item.pol,
        SYM: item.sym,
        FLR: item.flo,
        MEASUREMENTS: item.measurements,
        DEP: !item.depthpercent ? "" : (Number(item.depthpercent)).toFixed(2),
        "TABLE%": !item.tablepercent ? "" : (Number(item.tablepercent)).toFixed(2),
        "CR ANG": !item.crownangle ? "" : (Number(item.crownangle)).toFixed(2),
        LAB: item.lab,
        RAP: item.originalprice,
        DIS: parseFloat((Number(item.discount)).toFixed(2)),
        PPC: parseFloat((Number(item.discountprice)).toFixed(2)),
        TOTAL: parseFloat((Number(item.stoneprice)).toFixed(2)),
        LOCATION: item.location,
        STATUS: item.status,
        KEYTOSYMBOLS: item.keytosymbols ? item.keytosymbols : " ",
        MEDIA: {
          t: "s",
          v: "Media URL",
          l: {
            Target: item.stonemediaurl,
            Tooltip: "Click to open images & videos",
          }, TOTAL: (Number(item.total)).toFixed(2),
        },
        holdstonecustomerid: item.holdstonecustomerid,
        holdstoneuserid: item.holdstoneuserid,
        holdstonebrokerid: item.holdstonebrokerid,
        TABLEINC: item.tableinc ? item.tableinc : "",
        SIDEINC: item.sideinc ? item.sideinc : "",
        H_AND_A: item.h_and_a ? item.h_and_a : "",
        EYECLEAN: item.eyeclean ? item.eyeclean : "",
        TINGE: item.tinge ? item.tinge : "",
        MILKY: item.milky ? item.milky : "",
        OPEN: item.open ? item.open : "",
        LUSTER: item.luster ? item.luster : "",
        TABLEBLACK: item.tableblack ? "YES" : "NO",
        SIDEBLACK: item.sideblack ? "YES" : "NO",
      };
    });

    const calculatedRow = getSummaryData(rowdata);

    //addding last row for summary data
    const lastRow = Object.fromEntries(
      Constants.STOCK_EXCEL_KEYS.map(key => [key, calculatedRow[key] || ""])
    );

    //addding last row for summary data
    excelData.push(lastRow);

    const exportColumns = fullExcel
      ? [...Constants.STOCK_EXCEL_COLUMNS, ...Constants.EXCEL_OPTIONAL_COLUMNS]
      : Constants.STOCK_EXCEL_COLUMNS;

    createExcelFile(excelData, null, exportColumns, "PI-Stock.xlsx");
  }

  const getDetailPanelHeight = React.useCallback(() => 'auto', []);

  const getDetailPanelContent = React.useCallback(
    (row, mainData, columns) => <DetailPanelContent row={row} mainData={mainData} columns={columns} />,
    [columns],
  );

  function DetailPanelContent({ row: rowProp, mainData, columns }) {
    const [anchorEl1, setAnchorEl1] = React.useState(null);
    const open1 = Boolean(anchorEl1);
    const handleClick = (event) => {
      setAnchorEl1(event.currentTarget);
    };
    const handleCloseButton = () => {
      setAnchorEl1(null);
    };
    let row = mainData.filter(data => data.perfomaid === rowProp.id);
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size

    row.forEach((iData) => {
      let pricePerCarat = iData.discountprice;
      totalSize += iData.size;
      totalPrice += (iData.stoneprice);
      total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
    });

    let noOfSelectedStones = row.length;
    let selectedTotalSize = Utility.ConvertNumberWithSpecifiedDigits(totalSize);
    let selectedtotalPrice = Utility.ConvertNumberWithSpecifiedDigits(totalPrice);
    let selectedavgPrice = totalPrice > 0 ?
      Utility.ConvertNumberWithSpecifiedDigits(totalPrice / totalSize) :
      Utility.ConvertNumberWithSpecifiedDigits(0);
    let selectedAvgDiscount = totalPrice > 0 ?
      Utility.ConvertNumberWithSpecifiedDigits((100 - (totalPrice / total) * 100) * -1) :
      Utility.ConvertNumberWithSpecifiedDigits(0);

    return (
      <Stack
        sx={{ py: 2, height: '90%', boxSizing: 'border-box' }}
        direction="column"
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            width: "92vw",
            position: "relative",
            "& .MuiTablePagination-selectLabel": {
              marginTop: "15px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "15px",
            },
            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontWeight: Constants.defaultFontWeight,
            },
            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
              color: "#1976d2",
              padding: "4px 5px",
              borderRadius: "4px",
            },
            "& .css-cc8tf1": {
              fontWeight: Constants.defaultFontWeight,
            },
            height: 'auto',
            marginLeft: '16px',
          }}
        >
          <DataGridPro
            disableRowSelectionOnClick={false}
            density="compact"
            columns={columns}
            rows={row}
            getRowId={(row) => row.stoneid}
            sx={{
              '& .MuiDataGrid-columnHeader': {
                color: '#fff',
                backgroundColor: 'grey',
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "8px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "15px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "22px",
              },

              fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              maxHeight: '30vh',
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            hideFooter
          />
        </Box>
        <Box
          sx={{
            position: "absolute",
            left: "15%",
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            width: "60%",
            color: "black",
            fontWeight: 'normal',
            fontSize: Constants.defaultTableFontSize
          }}
        >
          <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
            <span>No of Stones: </span> <b>{noOfSelectedStones}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Total Weight: </span> <b>{selectedTotalSize}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Total Price: </span> <b>{selectedtotalPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Avg Price: </span> <b>{selectedavgPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Avg Discount: </span> <b>{selectedAvgDiscount}</b>
          </div>

          <Box
            sx={{
              alignItems: "center",
              ml: "235px",
              marginTop: "5px"
            }}
          >
            {!Utility.isReadAllowed(fullExcelPermission) ? (
              <Button
                component="label"
                variant="outlined"
                size="small"
                color="secondary"
                sx={{ ml: "5px", }}
                startIcon={<Download size="large" />}
                onClick={() => getExcelData(row, false)}
              >
                EXCEL
              </Button>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginLeft: "5px",
                  "& .MuiButton-startIcon": {
                    marginRight: "0px !important",
                    marginLeft: "-2px",
                  },
                  "& .MuiLoadingButton-loadingIndicator": { left: "7px" },
                }}
              >
                <LoadingButton
                  id="demo-customized-export-menu"
                  aria-controls={
                    open1 ? "demo-customized-export-menu" : undefined
                  }
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                  variant="outlined"
                  disableElevation
                  onClick={handleClick}
                  sx={{
                    color: "#2e7d32",
                    borderRadius: "4px",
                    border: "1px solid rgba(46, 125, 50, 0.5)",
                    padding: "2px 2px 2px 8px",
                    cursor: "pointer",
                  }}
                  loadingPosition="start"
                  startIcon={<TbTableExport size={18} />}
                >
                  <span style={{ fontSize: "14px", marginLeft: "4px" }}>EXPORT</span>
                  <KeyboardArrowDownIcon />
                </LoadingButton>

                <StyledMenuButtons
                  id="demo-customized-export-menu"
                  MenuListProps={{
                    "aria-labelledby": "demo-customized-export-menu",
                    style: {
                      maxHeight: 250,
                    },
                  }}
                  anchorEl={anchorEl1}
                  open={anchorEl1}
                  onClose={() => handleCloseButton()}
                >
                  <MenuItem>
                    {Utility.isReadAllowed(fullExcelPermission) &&
                      <Button
                        component="label"
                        variant="outlined"
                        size="small"
                        color="secondary"
                        sx={{
                          ml: "5px",
                          minWidth: buttonMinWidth,
                          justifyContent: "flex-start",
                          textAlign: "left",
                          "& .MuiButton-startIcon": {
                            marginRight: "1px",
                            marginLeft: "0px",
                          },
                        }}
                        startIcon={<Download />}
                        onClick={() => {
                          getExcelData(row, true);
                          handleCloseButton()
                        }}
                      >
                        FULL EXCEL
                      </Button>
                    }
                  </MenuItem>
                  <MenuItem>
                    <Button
                      component="label"
                      variant="outlined"
                      size="small"
                      color="secondary"
                      sx={{
                        ml: "5px",
                        minWidth: buttonMinWidth,
                        justifyContent: "flex-start",
                        textAlign: "left",
                        "& .MuiButton-startIcon": {
                          marginRight: "1px",
                          marginLeft: "0px",
                        },
                      }}
                      startIcon={<Download />}
                      onClick={() => {
                        getExcelData(row, false);
                        handleCloseButton()
                      }}
                    >
                      EXCEL
                    </Button>
                  </MenuItem>
                </StyledMenuButtons>
              </Box>
            )}
          </Box>

        </Box>
      </Stack >
    );
  }

  const isEmployee = Constants.loggedInUser.usertype === "E";
  const canUpdate = Utility.isAddAllowed(local_Permission) || Utility.isUpdateAllowed(invoice_Permission);
  const canDelete = Utility.isDeleteAllowed(local_Permission);
  const materialColumns = isEmployee ? (
    canUpdate && canDelete ? materialDefaultColumns : (
      canUpdate || canDelete ?
        materialDefaultColumns.filter((col) => canUpdate ? col.field !== "deleteproforma" : col.field !== "converttoinvoice") :
        materialDefaultColumns.filter((col) => col.field !== "deleteproforma" && col.field !== "converttoinvoice")
    )
  ) : materialDefaultColumns.filter((col) => col.field !== "deleteproforma" && col.field !== "converttoinvoice");

  const CustomToolbar = () => {
    const [exportMenu, setExportMenu] = useState(undefined);
    return (
      <GridToolbarContainer
        sx={{
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        {!groupBy ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <CommonStoneSelection
              title={"Enter Multiple Stone Ids"}
              handleSelection={handleSelection}
              buttonDisabled={mainData.length === 0}
            />
            <Tooltip title={"Start Scan"}>
              <IconButton
                color={"success"}
                onClick={() => startScanning()}
                disabled={mainData.length === 0}
              >
                {<VscRunAll />}
              </IconButton>
            </Tooltip>
          </Box>
        ) : null}
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
        <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
        {!groupBy ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
              minWidth: 0,
              px: 1,
            }}
          >
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              useFlexGap
              flexWrap="wrap"
              sx={{
                width: "100%",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: { xs: "flex-start", sm: "flex-start" },
              }}
            >
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                No of Stones: <b>{noOfSelectedStones}</b>
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                Total Weight: <b>{selectedTotalSize}</b>
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                Total Price: <b>{selectedtotalPrice}</b>
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                Avg Price: <b>{selectedavgPrice}</b>
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                Avg Discount: <b>{selectedAvgDiscount}</b>
              </Typography>
            </Stack>
          </Box>
        ) : null}

        {groupBy ? (
          <>
            {memoLoader ? (
              <CircularProgress size="1rem" />
            ) : (
              <Tooltip title="Reload List">
                <RefreshOutlinedIcon
                  onClick={() => prepareAllUserData()}
                  color="primary"
                  fontSize="medium"
                  sx={{ cursor: "pointer", mt: 1 }}
                />
              </Tooltip>
            )}
          </>
        ) : null}
        {!groupBy ? (
          <>
            {memoLoader ? (
              <CircularProgress size="1rem" />
            ) : (
              <Tooltip title="Reload List">
                <RefreshOutlinedIcon
                  onClick={() => {
                    handleSearch()
                  }}
                  color="primary"
                  fontSize="medium"
                  sx={{ cursor: "pointer" }}
                />
              </Tooltip>
            )}
            <LoadingButton
              id="demo-customized-export-menu"
              aria-controls={exportMenu ? 'demo-customized-export-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={exportMenu ? 'true' : undefined}
              variant="outlined"
              disableElevation
              onClick={(e) => setExportMenu(e.currentTarget)}
              sx={{
                color: '#2e7d32',
                borderRadius: "4px",
                border: "1px solid rgba(46, 125, 50, 0.5)",
                padding: "2px 2px 2px 8px",
                cursor: "pointer"
              }}
              // loading={offlineLoader}
              loadingPosition="start"
              startIcon={<TbTableExport size={18} />}
            >
              <span style={{ fontSize: "14px", marginLeft: "4px" }}>EXPORT</span>
              <KeyboardArrowDownIcon />
            </LoadingButton>
            <StyledMenuButtons
              id="demo-customized-export-menu"
              MenuListProps={{
                'aria-labelledby': 'demo-customized-export-menu',
                style: {
                  maxHeight: 250,
                },
              }}
              anchorEl={exportMenu}
              open={exportMenu}
              onClose={() => setExportMenu(null)}
            >
              <MenuItem>
                <Box sx={{ "& .MuiButton-startIcon": { marginRight: "0px !important", marginLeft: "-2px" }, }}>
                  {Utility.isReadAllowed(fullExcelPermission) &&
                    <Button
                      component="label"
                      variant="outlined"
                      size="small"
                      color="secondary"
                      sx={{ ml: "5px", }}
                      startIcon={<Download size="large" />}
                      onClick={() => {
                        getExcelData(mainData, true);
                        setExportMenu(null);
                      }}
                    >
                      FULL EXCEL
                    </Button>
                  }
                </Box>
              </MenuItem>
              <MenuItem>
                <Button
                  component="label"
                  variant="outlined"
                  size="small"
                  color="secondary"
                  sx={{
                    ml: "5px",
                    minWidth: buttonMinWidth,
                    justifyContent: "flex-start",
                    textAlign: "left",
                    "& .MuiButton-startIcon": {
                      marginRight: "1px",
                      marginLeft: "0px",
                    },
                  }}
                  startIcon={<Download />}
                  onClick={() => {
                    getExcelData(mainData, false);
                    setExportMenu(null);
                  }}
                >
                  EXCEL
                </Button>
              </MenuItem>
              <MenuItem>
                <Button
                  component="label"
                  variant="outlined"
                  size="small"
                  color="secondary"
                  sx={{
                    ml: "5px",
                    minWidth: buttonMinWidth,
                    justifyContent: "flex-start",
                    textAlign: "left",
                    "& .MuiButton-startIcon": {
                      marginRight: "1px",
                      marginLeft: "0px",
                    },
                  }}
                  startIcon={<Download size="large" />}
                  onClick={() => {
                    createPdf()
                    setExportMenu(null);
                  }}
                  disabled={enableConvertToInvoiceButton}
                >
                  PDF
                </Button>
              </MenuItem>
            </StyledMenuButtons>
            {Constants.loggedInUser.usertype === "E" && Utility.isAddAllowed(local_Permission) ? (
              <Box>
                <Tooltip title="Convert Proforma to Invoice">
                  <Button
                    variant="contained"
                    component="label"
                    size="small"
                    startIcon={<FaFileInvoice />}
                    color="success"
                    disabled={enableConvertToInvoiceButton}
                    onClick={() => {
                      let stonetype;
                      let flag = true;
                      mainData.map(iStone => {
                        if (selectionModel.includes(iStone.stoneid) && flag) {
                          if (stonetype && stonetype !== iStone.stonetype) {
                            if (stonetype === 'N' || iStone.stonetype === 'N') {
                              flag = false;
                              setShowSuccessSnackbar(true);
                              setSuccessMessage("Stonetype mismatch. Select stones with same stonetype");
                              setSnackbarVariant("warning");
                            }
                          } else if (!stonetype) {
                            stonetype = iStone.stonetype;
                          }
                        }
                        return true;
                      })

                      if (flag) {
                        setShowSellModal(true);
                        setStoneData(
                          mainData.filter((data) => selectionModel.includes(data.stoneid))
                        );
                      }
                    }}
                  >
                    Convert to Invoice
                  </Button>
                </Tooltip>
              </Box>
            ) : null}
            {Constants.loggedInUser.usertype === "E" && Utility.isDeleteAllowed(local_Permission) ? (
              <Box>
                <Tooltip title="Delete Stones">
                  <Button
                    variant="contained"
                    component="label"
                    size="small"
                    startIcon={<DeleteIcon />}
                    color="error"
                    disabled={selectionModel.length === 0}
                    onClick={() => {
                      setShow(true);
                      setProformaIds(selectionModel);
                      setDeleteModalTitle(
                        "Are you sure you want to Delete these stones ?"
                      );
                    }}
                  >
                    Delete
                  </Button>
                </Tooltip>
              </Box>
            ) : null}
          </>
        ) : null}
        <GridToolbarQuickFilter debounceMs={500} />
      </GridToolbarContainer>
    );
  }

  return (
    <div>

      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneId}
          handleClose={handleClose}
        />
      ) : null}

      {showSuccessSnackbar ? (
        <CommonSnackbar
          show={true}
          message={successMessage}
          variant={snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          title={snackbarVariant === "success" ? "Success" : snackbarVariant === "warning" ? "Warning" : "Failed"}
          handleClose={handleClose}
        />
      ) : null}

      {/*need to send pdf in byte string to modal */}
      <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={pdfByte} pdfName={pdfName} />

      {showSellModal ? (
        <SellMemoModal
          sourceData={selectedProformas}
          show={true}
          setShow={setShowSellModal}
          handleValidation={handleValidation}
          handleInvoice={sellStones}
          handleUpdateProforma={updateProforma}
          handleUpdateProformaToInvoice={updateProformaToInvoice}
          stoneId={selectionModel}
          stockData={stoneData}
          customer={{
            value: selectedProformas[0].customerid,
            label: selectedProformas[0].customercompanyname,
          }}
          user={Constants.loggedInUser.id + " | " + Constants.loggedInUser.companyname}
          proformaButton={false}
          loading={loadingButton}
          saveloading={saveLoadingButton}
          saveInvoiceLoading={saveInvoiceLoadingButton}
          openInvoice={openInvoice}
          setOpenInvoice={setOpenInvoice}
        />
      ) : null}

      {show ? (
        <DeleteProformaModal
          show={show}
          setShow={setShow}
          handleValidation={handleValidation}
          handleSave={handleProformaDelete}
          proformaIds={proformaIds}
          deleteModalTitle={deleteModalTitle}
          loading={loadingDeleteButton}
        />
      ) : null}

      {showStoneMediaModal ? (
        <>
          <StoneMediaModal
            show={showStoneMediaModal}
            stoneMediaURL={stoneMediaURL}
            handleClose={() => setShowStoneMediaModal(false)}
          />
        </>
      ) : null}

      {showUserDetailModal ? (
        <UserDetailModal
          show={true}
          handleClose={() => setShowUserDetailModal(false)}
          handleSelect={(selectedOption) => {
            const selectedCustomers = customerData.customerOptions.filter(opt =>
              selectedOption.includes(opt.value)
            );
            setCustomerData({
              ...customerData,
              customer: selectedCustomers,
            });
            setShowUserDetailModal(false)
          }}
          userids={customerData.customerOptions.filter(option => option.value !== "*").map(cust => cust.value)}
          selectedIds={customerData.customer.length !== 0 ? customerData.customer.map(iCustomer => iCustomer.value) : []}
          usertype={"C"}
          loading={showUserDetailModal}
          isMulti={true}
        />
      ) : null}

      {Constants.loggedInUser.usertype !== "E" ? <NoPermission /> : (
        <Box>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <Box sx={{ alignSelf: "center", marginBottom: "10px" }}>
              <Typography>Customer Company {Constants.loggedInUser.usertype !== "C" ? "" : " :- "}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                maxWidth: "auto",
                marginBottom: "10px"
              }}
            >
              {Constants.loggedInUser.usertype !== "C" ? (
                <Box
                  sx={{
                    alignSelf: "center",
                    minWidth: "300px",
                    maxWidth: "370px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      isMulti
                      className="basic-single"
                      classNamePrefix="select"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={customerData.customer}
                      isSearchable={true}
                      name="Customer"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={customerData.customerOptions}
                      onChange={(selectedOption) => {
                        setCustomerData({
                          ...customerData,
                          customer: selectedOption,
                        });
                      }}
                    />
                  </Box>
                  <Tooltip title="View More Data">
                    <span style={{ cursor: "pointer", marginLeft: "15px", marginTop: "0px" }}>
                      <OpenInNewIcon
                        fontSize="medium"
                        color="action"
                        onClick={() => this.setState({ showUserDetailModal: true })}
                      />
                    </span>
                  </Tooltip>
                </Box>
              ) : (
                <Box sx={{ alignSelf: "center", mt: 1 }}>
                  <Typography fontWeight={Constants.defaultFontWeightBold} variant="h6">
                    {Constants.loggedInUser.companyname}
                  </Typography>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                width: "250px", display: "flex", flexDirection: "row", justifyContent: "space-between",
                "& .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root": {
                  height: "2.4rem",
                },
                "& .css-wb57ya-MuiFormControl-root-MuiTextField-root": {
                  marginTop: 0,
                }
              }}
              display={"flex"} gap="15px" mt={2} mb={1}>
              <Typography mt={1}>From</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="picker"
                  ampm={true}
                  renderInput={(props) => (
                    <TextField
                      fullWidth
                      {...props}
                      inputProps={{ ...props.inputProps, readOnly: true }}
                    />
                  )}
                  value={fromDate}
                  inputFormat="DD/MM/YYYY"
                  onChange={(newValue) => {
                    // Get the current time
                    const now = dayjs();

                    // Set startOfMonth to the first day of the selected month, but with the current system time
                    const fromDate = dayjs(newValue)
                      .hour(now.hour())
                      .minute(now.minute())
                      .second(now.second())
                      .millisecond(now.millisecond())
                      .toDate();

                    setFromDate(fromDate);
                  }}
                />
              </LocalizationProvider>
            </Box>
            <Box
              sx={{
                width: "250px", display: "flex", flexDirection: "row", justifyContent: "space-between",
                "& .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root": {
                  height: "2.5rem",
                },
                "& .css-wb57ya-MuiFormControl-root-MuiTextField-root": {
                  marginTop: 0,
                }

              }}
              display={"flex"} gap="15px" mt={2} mb={1}>
              {" "}
              <Typography mt={1}>To</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="picker"
                  ampm={true}
                  renderInput={(props) => (
                    <TextField
                      fullWidth
                      {...props}
                      inputProps={{ ...props.inputProps, readOnly: true }}
                    />
                  )}
                  error={false}
                  value={toDate}
                  inputFormat="DD/MM/YYYY"
                  onChange={(newValue) => {
                    // Get the current time
                    const now = dayjs();

                    // Set startOfMonth to the first day of the selected month, but with the current system time
                    const toDate = dayjs(newValue)
                      .hour(now.hour())
                      .minute(now.minute())
                      .second(now.second())
                      .millisecond(now.millisecond())
                      .toDate();

                    setToDate(toDate);
                  }}
                />
              </LocalizationProvider>
            </Box>
            <Box>
              <TextField
                margin="normal"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    padding: "9px 14px !important"
                  },
                  width: "15rem",
                }}
                multiline
                rows={1}
                placeholder="Enter stone or certificate Id"
                value={data}
                onChange={(e) => {
                  setData(Utility.ConvertNewLineToComma(e.target.value))
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
                mt: 1,
                marginLeft: "10px"
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <Switch
                        checked={groupBy}
                        onChange={() => setGroupBy(!groupBy)}
                      />
                      <Typography>By Proforma</Typography>
                    </Box>
                  }
                  label=""
                />
              </FormGroup>
              <LoadingButton
                sx={{ marginBottom: "10px" }}
                variant="contained"
                onClick={() => {
                  handleSearch();
                  if (data)
                    setGroupBy(false);
                }}
                startIcon={<SearchOutlinedIcon size="large" />}
                loading={memoLoader}
                loadingPosition="start"
                disabled={
                  customerData.customerOptions.length === 0 && Constants.loggedInUser.usertype !== "C"
                }
              >
                Search
              </LoadingButton>
            </Box>
          </Box>

          {!groupBy ? (
            <div>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  color: '#000',
                  width: "100%",
                  position: "relative",
                  "& .MuiTablePagination-selectLabel": {
                    marginTop: "15px",
                  },
                  "& .MuiTablePagination-displayedRows": {
                    marginTop: "15px",
                  },
                  "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                    fontWeight: Constants.defaultFontWeight,
                  },
                  "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                    color: "#1976d2",
                    padding: "4px 5px",
                    borderRadius: "4px",
                  },
                  "& .css-cc8tf1": {
                    fontWeight: Constants.defaultFontWeight,
                  },
                  height: '73vh'
                }}
              >
                <DataGridPro
                  disableRowSelectionOnClick={false}
                  sx={{
                    '& .MuiDataGrid-columnHeader': {
                      color: '#fff',
                      backgroundColor: 'grey',
                    },
                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                      py: "8px",
                    },
                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                      py: "15px",
                    },
                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                      py: "22px",
                    },

                    fontSize: Constants.defaultTableFontSize, fontWeight: 'bold'
                  }}
                  density="compact"
                  loading={memoLoader}
                  slots={{ toolbar: CustomToolbar }}
                  rows={mainData}
                  columns={columns}
                  getRowId={(row) => row.stoneid}
                  checkboxSelection={true}
                  onRowSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                  }}
                  rowSelectionModel={selectionModel}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        // Hide columns id, the other columns will remain visible
                        labname: false,
                        location: false,
                        country: false,
                      },
                    },
                    pagination: {
                      paginationModel: Constants.pageSize,
                    },
                  }}
                  pageSizeOptions={Constants.pageSizeOptions}
                  pagination
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { debounceMs: 500 },
                    },
                  }}
                />
              </Box>
            </div>
          ) : (
            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                width: "100%",
                position: "relative",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .lavenderCell": {
                  color: "#080808",
                  backgroundColor: "#D8BFD8",
                },
                height: "73vh",
              }}
            >
              <DataGridPro
                rowHeight={65}
                disableRowSelectionOnClick={true}
                density="compact"
                columns={materialColumns}
                rows={listData}
                sx={{
                  '& .MuiDataGrid-columnHeader': {
                    color: '#fff',
                    backgroundColor: 'grey',
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                    py: "4px",
                  },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                    py: "12px",
                  },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                    py: "18px",
                  },

                  '& .MuiDataGrid-row': {
                    whiteSpace: 'nowrap',
                  },
                  fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                }}
                slots={{ toolbar: CustomToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                getRowId={(row) => row.id}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns id, the other columns will remain visible
                      status: false
                    },
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                sortModel={[
                  {
                    field: 'id',
                    sort: 'desc',
                  },
                ]}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                getDetailPanelHeight={getDetailPanelHeight}
                getDetailPanelContent={({ row }) => getDetailPanelContent(row, mainData, columns)}
              />
            </Box>
          )}
        </Box>
      )}

    </div >
  );
};

export default Proforma;
